import Backbone from 'backbone'
import template from './checkbox-widget.hbs'
import checkboxOption from './checkbox-widget-option.hbs'
import FieldValueControl from 'scoreboard/datasets/records/field-value-control'
import _ from 'lodash'
import WidgetState from 'scoreboard/forms/model/widget-state'
const { DISABLED, TEXT_ONLY } = WidgetState
import { isFieldHiddenForUser, isEditableRecord } from 'scoreboard/forms/model/form'
import {getDialogDatasetOrDataset} from '../edit/pages-edit'

const CheckboxWidget = Backbone.View.extend({

	tagName: 'li',

	className: 'checkbox-widget',

	/**
	 * A checkbox widget in the forms section
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {FormWidget} options.widget the data for the widget
	 *
	 * @param {FormView} options.formView the FormView this form is
	 * participating in
	 *
	 * @param {FormDirector} options.formDirector
	 */
	initialize: function(options = {}) {
		this.options = options
		this.dataset = getDialogDatasetOrDataset(this.model)
		this.formView = this.options.formView
		this.widget = this.options.widget
	},

	render: function() {
		this.$el.empty().append(template(this.widget))
		this.controls = []
		const widgetsToShow = _.filter(this.widget.childWidgets, w =>
			!isFieldHiddenForUser(w.fieldId, this.dataset))
		_.each(widgetsToShow, childWidget => {
			// #52424 display non-editable fields as text only if there is a record
			const record = _.get(this.options.formDirector, 'record')
			// #56626
			// Manually Added Record fields have their checkboxes displayed,
			// but always disabled. Use this flag to ensure we don't add a label
			// unnecessarily due to how isEditableRecord is evaluated
			const isManuallyAddedField = this.dataset
				.isManuallyAddedFieldId(childWidget.fieldId)
			const state = !isEditableRecord(
				childWidget.fieldId, this.dataset, record
			) && !isManuallyAddedField ? TEXT_ONLY : this.widget.state

			let fieldValueControl = new FieldValueControl({
				model: this.dataset,
				fieldId: childWidget.fieldId,
				value: _.get(this.options.formDirector, `fieldValues.${childWidget.fieldId}`),
				record,
				formView: this.formView,
				label: childWidget.label,
				description: childWidget.description,
				checkbox: true,
				state,
				allowInput: !_.includes([TEXT_ONLY, DISABLED], this.widget.state)
			})
			this.controls.push(fieldValueControl)
			this.$('.checkbox-list').append(checkboxOption)
			this.$('.control').last().append(fieldValueControl.el)
			fieldValueControl.render()
		})
		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.controls], 'remove')
	}

})

export default CheckboxWidget
CheckboxWidget.__filename__ = 'forms/widgets/checkbox-widget.js'
